import React from "react";
import { Phone, MessageCircle, Mail, Instagram, Linkedin, Twitter } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";
import { CONTACT, waLink, telLink } from "../lib/contact";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-[#0B1020] text-slate-300 pt-20 md:pt-28 pb-10 relative overflow-hidden" data-testid="site-footer">
      <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-[60rem] h-40 rounded-full bg-blue-600/20 blur-3xl pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <a href="#top" className="inline-block" data-testid="footer-logo">
              <img src="/logo-dark.png" alt="Launch Mitra" className="h-16 md:h-20 w-auto select-none" draggable="false" />
            </a>
            <p className="mt-5 text-slate-400 max-w-md text-sm leading-relaxed">{t.footer.tagline}</p>
            <div className="mt-6 flex gap-3">
              {[Instagram, Linkedin, Twitter].map((I, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-10 h-10 rounded-full border border-white/10 hover:border-white/30 hover:bg-white/5 flex items-center justify-center transition"
                  data-testid={`footer-social-${i}`}
                  aria-label="Social link"
                >
                  <I className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold">{t.footer.sections.product}</div>
            <ul className="mt-5 space-y-3 text-sm">
              <li><a href="#services" className="hover:text-white transition">{t.footer.links.services}</a></li>
              <li><a href="#pricing" className="hover:text-white transition">{t.footer.links.pricing}</a></li>
              <li><a href="#portfolio" className="hover:text-white transition">{t.footer.links.portfolio}</a></li>
              <li><a href="#how" className="hover:text-white transition">{t.footer.links.process}</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold">{t.footer.sections.contact}</div>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <a href={telLink()} className="inline-flex items-center gap-2 hover:text-white transition" data-testid="footer-phone">
                  <Phone className="w-4 h-4 text-blue-400" /> {CONTACT.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={waLink()} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-white transition" data-testid="footer-whatsapp">
                  <MessageCircle className="w-4 h-4 text-emerald-400" /> WhatsApp Chat
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`} className="inline-flex items-center gap-2 hover:text-white transition" data-testid="footer-email">
                  <Mail className="w-4 h-4 text-violet-400" /> {CONTACT.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Launch Mitra. {t.footer.rights}</div>
          <div className="text-slate-500">{t.footer.built}</div>
        </div>
      </div>
    </footer>
  );
}
